/**
 * @packageDocumentation
 * @module Object
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isPrimitive } from '../../others';
import { setInBaseFunction } from '../setIn';
import { getFromBaseFunction } from '../getFrom';
/**
 * Immutably removes an item from an object or array at a given path
 *
 * @param {object} values
 * @param {string|string[]} path
 *
 * @return {object}
 */
export var removeFromBaseFunction = function (values, path) {
    var lastIndex = path.length - 1;
    var parentPath = __spread(path).slice(0, lastIndex); // []
    var propertyToRemove = path[lastIndex];
    var parentOfProperty = getFromBaseFunction(values, parentPath);
    if (parentOfProperty === undefined || isPrimitive(parentOfProperty)) {
        // if that branch has been removed, then nothing to see here
        return values;
    }
    // then we should remove the element
    var result = values;
    if (parentOfProperty[propertyToRemove] !== undefined) {
        var isArray = Array.isArray(parentOfProperty);
        if (isArray) {
            parentOfProperty = __spread(parentOfProperty);
            parentOfProperty.splice(propertyToRemove, 1);
        }
        else {
            var _a = parentOfProperty, _b = propertyToRemove, omitted = _a[_b], remaining = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            parentOfProperty = remaining;
        }
        result = setInBaseFunction(result, parentPath, parentOfProperty, false);
    }
    return result;
};
//# sourceMappingURL=removeFromBaseFunction.js.map